export default {
  "app.title": "بيت الحناء والعطارة | نظام الإدارة والمبيعات",
  "language.switch": "التبديل إلى الإنجليزية",
  "brand.name": "بيت الحناء والعطارة",
  "brand.logo": "شعار بيت الحناء والعطارة",
  "brand.tagline": "عناية طبيعية · عطارة",
  "common.back": "رجوع",
  "common.close": "إغلاق",
  "common.search": "بحث ذكي...",
  "common.empty": "لا توجد بيانات",
  "common.emptyDescription": "ستظهر البيانات هنا عند إضافتها.",
  "common.synced": "متزامن",
  "common.retry": "إعادة المحاولة",
  "common.loading": "جاري التحميل…",
  "common.product": "المنتج",
  "common.status": "الحالة",
  "common.total": "الإجمالي",
  "common.customer": "العميل",
  "common.payment": "طريقة الدفع",
  "common.invoiceNo": "رقم الفاتورة",
  "app.preparing": "جاري تجهيز بيت الحناء والعطارة...",
  "app.update": "يتوفر تحديث جديد للتطبيق",
  "app.updateNow": "تحديث الآن",
  "app.leaveTitle": "تأكيد الخروج من الشاشة",
  "app.stay": "البقاء هنا",
  "app.leave": "الخروج على أي حال",
  "nav.home": "الرئيسية",
  "nav.overview": "نظرة عامة",
  "nav.salesCustomers": "المبيعات والعملاء",
  "nav.dailySales": "المبيعات اليومية",
  "nav.sales": "المبيعات",
  "nav.customerFiles": "ملف العملاء",
  "nav.customers": "العملاء",
  "nav.legacySales": "مبيعات مرحّلة",
  "nav.legacy": "مرحّلة",
  "nav.productsInventory": "المنتجات والمخزون",
  "nav.productFiles": "ملف المنتجات",
  "nav.products": "المنتجات",
  "nav.inventoryCount": "المخزون والجرد",
  "nav.inventory": "المخزون",
  "nav.purchases": "المشتريات",
  "nav.expensesFull": "النفقات والنثريات",
  "nav.expenses": "النفقات",
  "nav.suppliers": "الموردون",
  "nav.pricingFull": "الأسعار والعروض",
  "nav.pricing": "الأسعار",
  "nav.marginsFull": "مراجعة الهوامش",
  "nav.margins": "الهوامش",
  "nav.dateLabels": "ملصقات التواريخ",
  "nav.labels": "الملصقات",
  "nav.reportsAdmin": "التقارير والإدارة",
  "nav.pnl": "الربح والخسارة",
  "nav.profit": "الربح",
  "nav.vatReturn": "الإقرار الضريبي",
  "nav.tax": "الضريبة",
  "nav.reports": "التقارير",
  "nav.employeesFull": "الموظفون والصلاحيات",
  "nav.employees": "الموظفون",
  "nav.auditFull": "سجل التدقيق",
  "nav.audit": "التدقيق",
  "nav.accountFull": "إعدادات الحساب",
  "nav.account": "الحساب",
  "nav.selling": "البيع",
  "nav.pos": "نقطة البيع",
  "nav.all": "كل الأقسام",
  "nav.sections": "الأقسام",
  "nav.logout": "تسجيل الخروج",
  "nav.out": "خروج",
  "nav.main": "التنقل الرئيسي",
  "nav.open": "فتح الأقسام",
  "nav.profile": "حسابي والأقسام",
  "nav.quick": "التنقل السريع",
  "nav.more": "المزيد",
  "role.admin": "مدير النظام",
  "role.cashier": "موظف مبيعات",
  "sync.connected": "متزامن لحظياً",
  "sync.offline": "إعادة الاتصال",
  "sync.connecting": "جاري الربط",
  "theme.light": "التبديل إلى الوضع الفاتح",
  "theme.dark": "التبديل إلى الوضع الداكن",
  "combo.empty": "لا يوجد خيار مطابق — اكتب القيمة كما تريدها",
  "combo.new": "قيمة جديدة — تُضاف عند الحفظ",
  "combo.open": "فتح قائمة {label}",
  "login.welcome": "أهلاً بك في بيت الحناء والعطارة",
  "login.description": "سجّل الدخول لإدارة العمل أو لبدء المبيعات من صندوق الكاشير.",
  "login.identifier": "رقم الجوال أو البريد الإلكتروني",
  "login.placeholder": "name@example.com أو 05xxxxxxxx",
  "login.password": "كلمة المرور",
  "login.hide": "إخفاء كلمة المرور",
  "login.show": "إظهار كلمة المرور",
  "login.forgot": "نسيت كلمة المرور؟",
  "login.busy": "جاري الدخول...",
  "login.submit": "تسجيل الدخول",
  "login.newEmployee": "موظف جديد؟ أنشئ حساب بائع",
  "login.approvalHint": "سيُرسل الطلب إلى الإدارة للموافقة",
  "login.back": "العودة لتسجيل الدخول",
  "login.recoverySent": "تم إرسال طلب الاستعادة",
  "login.recoverySentHint": "سيظهر الطلب فوراً لإدارة النظام لتعيين كلمة مرور مؤقتة لك.",
  "login.recovery": "استعادة كلمة المرور",
  "login.recoveryHint": "أدخل رقم الجوال أو البريد المسجل، وسيصل طلب آمن إلى إدارة النظام.",
  "login.sending": "جاري إرسال الطلب...",
  "login.requestRecovery": "إرسال طلب الاستعادة",
  "login.registered": "تم إرسال طلبك",
  "login.registeredHint": "سيظهر الحساب في لوحة تحكم الإدارة. يمكنك تسجيل الدخول بعد موافقة المدير.",
  "login.create": "إنشاء حساب بائع",
  "login.createHint": "أدخل بياناتك الصحيحة. لن يُفعّل الحساب إلا بعد موافقة إدارة بيت الحناء والعطارة.",
  "login.name": "الاسم الكامل",
  "login.namePlaceholder": "الاسم كما يظهر في الفواتير",
  "login.phone": "رقم الجوال",
  "login.email": "البريد الإلكتروني",
  "login.confirmPassword": "تأكيد كلمة المرور",
  "login.registerSubmit": "إنشاء الحساب وإرساله للإدارة",
  "login.security": "جلسة مشفرة وصلاحيات منفصلة لكل موظف",
  "login.quote": "«كل تفاصيل العمل في مكان واحد، من أول عملية بيع إلى آخر قطعة في المخزون.»",
  "login.teamQuote": "«فريق واحد، مبيعات مترابطة، وإدارة تعرف كل ما يحدث لحظة بلحظة.»",
  "login.system": "نظام العمليات المتكامل لبيت الحناء والعطارة",
  "errors.passwordMismatch": "كلمتا المرور غير متطابقتين",
  "errors.requestFailed": "تعذر إكمال الطلب",
  "errors.network": "تعذر الاتصال بالخادم. تحقق من الاتصال ثم أعد المحاولة.",
  "errors.invalidCredentials": "بيانات الدخول غير صحيحة",
  "errors.pendingAccount": "حسابك بانتظار موافقة الإدارة",
  "errors.suspendedAccount": "الحساب موقوف، تواصل مع الإدارة",
  "errors.loginRateLimit": "محاولات كثيرة. أعد المحاولة بعد {seconds} ثانية.",
  "errors.registerRateLimit": "محاولات تسجيل كثيرة. أعد المحاولة لاحقاً.",
  "errors.nameRequired": "الاسم مطلوب",
  "errors.invalidPhone": "أدخل رقم جوال سعودي صحيحاً يبدأ بـ 05",
  "errors.invalidEmail": "أدخل بريداً إلكترونياً صحيحاً",
  "errors.shortPassword": "كلمة المرور يجب ألا تقل عن 8 أحرف",
  "errors.duplicateAccount": "رقم الجوال أو البريد مسجل مسبقاً",
  "errors.identifierRequired": "أدخل رقم الجوال أو البريد الإلكتروني",
  "dashboard.trendLabel": "مبيعات آخر 14 يوماً",
  "dashboard.last14": "آخر 14 يوماً",
  "dashboard.today": "اليوم",
  "dashboard.daySheet": "ورقة اليوم",
  "dashboard.netSales": "صافي مبيعات اليوم",
  "dashboard.profitNotes": "ملاحظات على حساب الربح",
  "dashboard.transparency": "شفافية كاملة — الرقم بلا تحفّظاته يضلّل",
  "dashboard.fillCosts": "تعبئة التكاليف",
  "dashboard.reviewMargins": "راجع الهوامش",
  "dashboard.summary": "ملخص أداء الأعمال اليوم",
  "dashboard.live": "مباشر",
  "dashboard.loading": "جاري تحميل البيانات…",
  "dashboard.noComparison": "لا توجد مبيعات أمس للمقارنة",
  "dashboard.completed": "فواتير بيع مكتملة",
  "dashboard.profitBasis": "بعد التكلفة والخصم وبلا ضريبة",
  "dashboard.invoiceCount": "عدد فواتير البيع",
  "dashboard.average": "متوسط قيمة الطلب",
  "dashboard.perInvoice": "لكل فاتورة بيع",
  "dashboard.newCustomers": "العملاء الجدد",
  "dashboard.registeredToday": "سجّلوا اليوم",
  "dashboard.profit": "الربح التقديري",
  "dashboard.stockAlerts": "تنبيهات المخزون",
  "dashboard.viewAll": "عرض الكل",
  "dashboard.available": "المتاح",
  "dashboard.minimum": "الحد الأدنى",
  "dashboard.low": "منخفض",
  "dashboard.stockGood": "المخزون بحالة جيدة",
  "dashboard.noLowStock": "لا توجد أصناف تحت حد التنبيه حالياً",
  "dashboard.recent": "الفواتير الأخيرة",
  "dashboard.noInvoices": "لا توجد فواتير اليوم",
  "dashboard.newInvoicesHint": "ستظهر الفواتير الجديدة هنا تلقائياً",
  "dashboard.held": "الفواتير المعلّقة",
  "dashboard.heldHint": "ليست مبيعات — لا تدخل التقارير",
  "dashboard.noHeld": "لا توجد فواتير معلّقة",
  "dashboard.noHeldHint": "الفواتير المعلّقة تظهر هنا عند تعليق عملية بيع",
  "dashboard.topProducts": "أعلى المنتجات مبيعاً",
  "dashboard.byQuantity": "حسب الكمية المباعة اليوم",
  "dashboard.noSales": "لا توجد مبيعات بعد",
  "dashboard.topHint": "ستظهر المنتجات الأكثر مبيعاً هنا",
  "dashboard.quick": "إجراءات سريعة",
  "dashboard.newPurchase": "إنشاء طلب شراء",
  "dashboard.purchaseHint": "إضافة توريد جديد للمخزون",
  "dashboard.newQuote": "إنشاء عرض سعر",
  "dashboard.quoteHint": "عرض احترافي لعميل",
  "dashboard.change": "{change}% عن أمس",
  "dashboard.returns": {
    "one": "مرتجع واحد بقيمة {amount}",
    "two": "مرتجعان بقيمة {amount}",
    "few": "{count} مرتجعات بقيمة {amount}",
    "other": "{count} مرتجع بقيمة {amount}"
  },
  "dashboard.margin": "هامش {margin}% · بعد التكلفة والخصم وبلا ضريبة",
  "dashboard.updated": "آخر تحديث: {time}",
  "dashboard.now": "الآن",
  "dashboard.minutesAgo": {
    "zero": "الآن",
    "one": "منذ دقيقة",
    "two": "منذ دقيقتين",
    "few": "منذ {count} دقائق",
    "many": "منذ {count} دقيقة",
    "other": "منذ {count} دقيقة"
  },
  "dashboard.hoursAgo": {
    "zero": "الآن",
    "one": "منذ ساعة",
    "two": "منذ ساعتين",
    "few": "منذ {count} ساعات",
    "many": "منذ {count} ساعة",
    "other": "منذ {count} ساعة"
  },
  "dashboard.attention": {
    "one": "صنف يحتاج انتباه",
    "two": "صنفان يحتاجان انتباه",
    "few": "{count} أصناف تحتاج انتباه",
    "other": "{count} صنف يحتاج انتباه"
  },
  "dashboard.invoicesToday": {
    "one": "فاتورة واحدة · اليوم",
    "two": "فاتورتان · اليوم",
    "few": "{count} فواتير · اليوم",
    "other": "{count} فاتورة · اليوم"
  },
  "dashboard.heldDetails": "{employee} · {count} صنف · {date}",
  "dashboard.unitsSold": {
    "one": "وحدة واحدة مباعة",
    "two": "وحدتان مباعتان",
    "few": "{count} وحدات مباعة",
    "other": "{count} وحدة مباعة"
  },
  "dashboard.uncovered": "مبيعات اليوم بقيمة {amount} من {count} صنف بلا تكلفة مسجّلة — مستبعدة من الربح حتى لا يتضخّم.",
  "dashboard.missingCosts": "{count} صنف نشط بلا تكلفة.",
  "dashboard.negativeMargin": "{count} صنف تكلفته تساوي سعر بيعه أو تفوقه — كل قطعة تُباع بخسارة.",
  "dashboard.openAmount": "المبلغ المفتوح بلغ {share}% من مبيعات اليوم ({amount}) — ربح هذا الجزء تقدير بنسبة تكلفة لا حساب من فواتير شراء.",
  "payment.cash": "كاش",
  "payment.card": "بطاقة",
  "payment.credit": "دفع بالاجل",
  "payment.balance": "رصيد العميل",
  "payment.split": "متعدد",
  "status.credit": "آجلة",
  "status.paid": "مكتملة",
  "status.return": "مرتجع",
  "install.installed": "التطبيق مثبت",
  "install.where": "أين أجد التطبيق",
  "install.button": "تثبيت التطبيق",
  "install.alreadyButton": "التطبيق مثبت — أين أجده؟",
  "install.title": "تثبيت بيت الحناء والعطارة",
  "install.alreadyHint": "التطبيق مثبَّت على هذا الجهاز فعلاً، ولهذا لا يفتح المتصفح نافذة تثبيت جديدة.",
  "install.description": "يمكن تثبيت النظام كتطبيق مستقل، فيفتح بنافذته الخاصة بلا شريط عناوين، ويظهر بأيقونة مثل أي برنامج.",
  "install.location": "أين يذهب التطبيق بعد التثبيت؟",
  "install.windows": "على الكمبيوتر (ويندوز)",
  "install.windowsHint": "لا يوضع على سطح المكتب تلقائياً. تجده في قائمة ابدأ بالبحث عن «بيت الحناء»، أو بفتح chrome://apps في كروم. ومن قائمة ابدأ: زر يمين على اسمه ← «تثبيت على شريط المهام» أو «فتح موقع الملف» لإنشاء اختصار على سطح المكتب.",
  "install.android": "على أندرويد",
  "install.androidHint": "يظهر في درج التطبيقات مع بقية التطبيقات، وغالباً على الشاشة الرئيسية. إن لم تجده: اسحب لأعلى في الشاشة الرئيسية واكتب «بيت الحناء».",
  "install.ios": "على آيفون وآيباد",
  "install.iosHint": "سفاري فقط: زر المشاركة ← «إضافة إلى الشاشة الرئيسية». كروم على آيفون لا يثبّت التطبيقات.",
  "install.browser": "التثبيت من قائمة المتصفح",
  "install.browserHint": "إن لم يعمل هذا الزر: افتح قائمة كروم (⋮) ← «بث وحفظ ومشاركة» أو «تطبيقات» ← «تثبيت بيت الحناء والعطارة». وعلى ويندوز تظهر أيقونة تثبيت صغيرة في يسار شريط العنوان.",
  "install.iconHint": "لتحديث أيقونة تطبيق مثبَّت مسبقاً: احذفه من الجهاز ثم أعد تثبيته — الأنظمة لا تُحدّث أيقونة تطبيق قائم مهما نُشر من تحديثات.",
  "payment.bank": "تحويل بنكي",
  "payment.transfer": "تحويل",
  "payment.multi": "دفع متعدد",
  "status.completed": "مكتمل",
  "status.settled": "مدفوعة",
  "status.partReturned": "مرتجع جزئي",
  "account.title": "إعدادات الحساب",
  "account.description": "تعديل اسم المستخدم ورقم الجوال وكلمة المرور",
  "account.protected": "حساب محمي",
  "account.userData": "بيانات المستخدم",
  "account.userDataHint": "سيظهر الاسم الجديد في الشريط العلوي وعلى العمليات اللاحقة.",
  "account.username": "اسم المستخدم",
  "account.email": "البريد الإلكتروني",
  "account.phone": "رقم الجوال (يُستخدم لتسجيل الدخول)",
  "account.passwordSection": "تأكيد الهوية وتغيير كلمة المرور",
  "account.passwordHint": "كلمة المرور الحالية مطلوبة عند تغيير رقم الجوال أو كلمة المرور.",
  "account.currentPassword": "كلمة المرور الحالية",
  "account.newPassword": "كلمة المرور الجديدة",
  "account.confirmPassword": "تأكيد كلمة المرور الجديدة",
  "account.saving": "جاري الحفظ...",
  "account.save": "حفظ التعديلات",
  "account.securityTitle": "حماية الحساب",
  "account.securityDescription": "عند تغيير كلمة المرور سيتم إنهاء جميع الجلسات الأخرى، بينما تبقى جلستك الحالية فعالة.",
  "account.securityLength": "استخدم 8 أحرف على الأقل",
  "account.securityShare": "لا تشارك كلمة المرور مع أي موظف",
  "account.securitySeller": "لكل بائع حساب مستقل مرتبط بمبيعاته",
  "account.errorPasswordMismatch": "كلمتا المرور الجديدة غير متطابقتين",
  "account.errorPhone": "أدخل رقم جوال سعودي صحيحاً يبدأ بـ 05",
  "account.errorCurrentPassword": "أدخل كلمة المرور الحالية لتأكيد التغيير",
  "account.noChange": "لا يوجد تغيير",
  "account.updated": "تم تحديث: {fields}",
  "dateLabels.title": "ملصقات تاريخ المنتجات",
  "dateLabels.description": "اختر الصنف وحدّد تاريخَي الإنتاج والانتهاء ثم اطبع الملصق — لاشتراطات البلدية",
  "dateLabels.noticeTitle": "ملصق مطابق لاشتراطات العرض",
  "dateLabels.noticeDescription": "يلزق على كل عبوة قبل عرضها للبيع: اسم المنتج وتاريخا الإنتاج والانتهاء يدخلهما الموظف من عنده.",
  "dateLabels.search": "ابحث بالاسم أو SKU أو الباركود...",
  "dateLabels.count": {"one":"{count} صنف","two":"صنفان","few":"{count} أصناف","many":"{count} صنفاً","other":"{count} صنف"},
  "dateLabels.product": "المنتج",
  "dateLabels.code": "الرمز",
  "dateLabels.category": "التصنيف",
  "dateLabels.action": "الإجراء",
  "dateLabels.printDate": "طباعة تاريخ",
  "dateLabels.openAmount": "مبلغ مفتوح",
  "dateLabels.empty": "لا توجد منتجات مطابقة",
  "dateLabels.modalTitle": "ملصق تاريخ — {name}",
  "dateLabels.production": "تاريخ الإنتاج",
  "dateLabels.expiry": "تاريخ الانتهاء",
  "dateLabels.sizePortrait": "4.5×6.5 سم عمودي — ورقك 6.5×4.5",
  "dateLabels.sizeLandscape": "6.5×4.5 سم أفقي",
  "dateLabels.sizeMedium": "ملصق متوسط",
  "dateLabels.brandLogo": "شعار بيت الحناء والعطارة",
  "dateLabels.expiresOn": "ينتهي في",
  "dateLabels.errorProduction": "اختر تاريخ الإنتاج",
  "dateLabels.errorExpiry": "اختر تاريخ الانتهاء",
  "dateLabels.errorOrder": "تاريخ الانتهاء قبل تاريخ الإنتاج",
  "dateLabels.printHint": "الطباعة عمودية 4.5×6.5 سم موزونة بالمنتصف لورقك 6.5×4.5. الهوامش «بلا» والمقياس 100%.",
  "dateLabels.close": "إغلاق",
  "dateLabels.print": "طباعة الملصق",

};
